import axios from 'axios';

import { ERROR_GENERAL } from '../../../../shared/constants';
import { headersWithCSRF } from '../../../../shared/utils/csrf';
import { apiClient, DECEDENTS } from '../../../shared/api';
import { DEFAULT_PER_PAGE } from '../../../shared/constants';

const INCLUDE_PARAMS = 'owner,tags';

const FILTER_PARAMS = [
  { filterType: 'owners', urlParam: 'with_owners' },
  { filterType: 'tags', urlParam: 'with_tags' },
];

const buildFilterParams = ({ activeFilters, searchQuery }) => {
  const filter = {};

  if (searchQuery) {
    filter.full_name = searchQuery;
  }

  FILTER_PARAMS.forEach(({ filterType, urlParam }) => {
    if (activeFilters[filterType].length > 0) {
      filter[urlParam] = activeFilters[filterType].join(',');
    }
  });

  return Object.keys(filter).length > 0 ? { filter } : {};
};

export const createDecedent = async (decedentData) => {
  const { firstName, lastName } = decedentData;

  const requestBody = {
    decedent: {
      first_name: firstName,
      last_name: lastName,
      website_id: 1, // TODO: Change website_id.
    },
  };

  try {
    const response = await axios.post(DECEDENTS, requestBody, {
      headers: headersWithCSRF,
    });

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || ERROR_GENERAL);
  }
};

export const fetchDecedents = async ({
  activeFilters,
  decedentName,
  page = 1,
  perPage = DEFAULT_PER_PAGE,
}) => {
  const params = {
    include: INCLUDE_PARAMS,
    ...buildFilterParams({ activeFilters, searchQuery: decedentName }),
    page: {
      number: page,
      size: perPage,
    },
  };

  const response = await apiClient.get(DECEDENTS, {
    includeWebsite: true,
    params,
  });

  return response.data;
};
